import { action } from 'satcheljs/lib/legacy';
export default action('updateIsExpanding')(function updateIsExpanding(recipient, isExpanding) {
    recipient.isExpanding = isExpanding;
});
//# sourceMappingURL=updateIsExpanding.js.map